export default __webpack_public_path__ + "static/media/test-two.64f9a422.svg";